import { useScrollReveal } from '@/hooks/useScrollReveal';

const LegalTeam = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      data-testid="legal-team-section"
      className={`legal-section section-reveal ${isVisible ? 'visible' : ''}`}
    >
      <div className="legal-content">
        <h2 className="legal-h2" data-testid="legal-team-h2">
          One named person. You always know who.
        </h2>

        <div className="legal-team-solo mt-10" data-testid="legal-team-vino">
          <h3 className="legal-team-name">Vino, founder</h3>
          <p className="legal-body mt-3">
            Owns the decision, the scope, and accountability for the outcome. Co-founder and CEO of Bottega Studios, a deep-tech company in real-time rendering and compression of volumetric and light-field content, whose technology assets were acquired by Snap Inc. in 2022.
          </p>
        </div>

        <p className="legal-body mt-10" data-testid="legal-team-closing">
          No anonymous bench. No subcontractor you never meet. If you are told who is doing the work, you can hold someone to it.
        </p>
      </div>
    </section>
  );
};

export default LegalTeam;
